// extracted by mini-css-extract-plugin
export default {"noArrow":"CustomTemplateDropdown_noArrow__2KSxj"};